// extracted by mini-css-extract-plugin
module.exports = {"menu":"WaiverAddTicketButton_menu__2mQfr","arrow":"WaiverAddTicketButton_arrow__1TkR-"};